import styled from "styled-components"
import { Box } from "@mui/material"

export const HeaderContainer = styled(Box)`
    width: 100%;
    img {
        width: 100%;
    }
`